import React, { useEffect, useState, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Container, Form, FormControl, Nav, Navbar, NavDropdown, Row, Col } from 'react-bootstrap';
import useFitText from "use-fit-text";

import logo from './logo.svg';
import headShot from './headShot.jpeg'
import iModX from './Images/iModX.svg';
import modellicity from './Images/modellicity.png';
import puzzul from './Images/puzzul.png';
import bfocus from './Images/BFOCUS.png';
import fairly from './Images/fairly.png';
import iModXGif from './Images/iModXCompany.gif'

import basilSinger from './Images/basil-singer.jpg'
import davidVanBruwaene from './Images/David-Van-Bruwaene.jpeg'
import fionLeeMadan from './Images/Fion-Lee-Madan.jpeg'
import kristinaFlynn from './Images/kristina-flynn.jpeg'
import connieAmartey from './Images/connie-amartey.jpeg'
import alexShipilov from './Images/alex-shipilov.jpg'
import yapingJiang from './Images/YapingJiang.png'


import './App.css';

const STATE = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
}

function useTransitionState(duration = 1000) {
  const [state, setState] = useState("");

  useEffect(() => {

    if (state === STATE.ENTERING) {
      let timerID = setTimeout(() => { setState(STATE.ENTERED) }, duration);
      return () => {
        clearTimeout(timerID);
      }
    } else if (state === STATE.EXITING) {
      let timerID = setTimeout(() => { setState(STATE.EXITED) }, duration);
      return () => {
        clearTimeout(timerID);
      }
    } else {
      return () => {

      }
    }

  })
  return { state, setState };
}

function useTransitionControl(duration = 1000) {
  const { state, setState } = useTransitionState(duration);

  const enter = () => {
    if (state !== STATE.EXITING) {
      setState(STATE.ENTERING);
    }
  }

  const exit = () => {
    if (state !== STATE.ENTERING) {
      setState(STATE.EXITING);
    }
  }

  return { state, enter, exit };


}

const defaultStyle = {
  transition: 'scaleY 500ms ease-in-out',
  scaleY: 1
}

const transitionStyles = (state: string) => {

  if (state === STATE.ENTERED) {
    return { scaleY: 0 };
  } else if (state === STATE.ENTERING) {
    return { scaleY: 0 };
  } else if (state === STATE.EXITING) {
    return { scaleY: 1 };
  } else if (state === STATE.EXITED) {
    return { scaleY: 1 };
  } else {
    return {};
  }
}

interface Founder {
  name:string;
  title:string;
  email:string;
  image:string;
}


const Block: React.FC<{
  vis:boolean, 
  setVis:Function, 
  logo:string, 
  heading:string, 
  backgroundColor:string, 
  textColor?:string,
  founders:Array<Founder>, 
  fullText:any
}> = ({ 
  vis,
  setVis,
  logo,
  heading,
  backgroundColor,
  textColor,
  founders,
  fullText }) => {

    const onStart = useCallback(() => {
      console.log("Example 3 resizing started");
    }, []);
    const onFinish = useCallback((fontSize: number) => {
      console.log("Example 3 resizing finished", fontSize);
    }, []);


    const { fontSize, ref } = useFitText({onStart, onFinish  });
    
    if (!textColor){
      textColor ="#FFFFFF"
    }


return <><Row  className="d-flex d-md-none" onClick={()=>{setVis(!vis)}} style={{ background:backgroundColor }}>
          <Col  />
          <Col  style={{textAlign:"center"}}><img src={logo} height={60} style={{marginTop:"40px"}} /></Col>
          <Col  />
        </Row>

        <Row className="d-flex d-md-none" onClick={()=>{setVis(!vis)}} style={{ background: backgroundColor, color:textColor}}>
        <Col xs="12" style={{ padding: "20px" }}>
            <p>{heading}</p>
            <div style={{textAlign:"center"}}><h3>{vis?"Reduce":"Expand"}</h3></div> </Col>

        </Row>

        {vis?<><Row className="d-flex d-md-none" onClick={()=>{setVis(false)}} style={{ background: backgroundColor, color:textColor, paddingTop:"20px", paddingBottom:"20px"  }}>
        <Row style={{ marginBottom: "auto",verticalAlign:"bottom", paddingTop:"20px", marginLeft:"20px", marginRight:"20px" }}>

          {founders.map((e,index)=>{

if (founders.length===1){
  return <>
  <Col/>
  <Col key={heading+index}>
  <div><img className="d-block" src={e.image} style={{ maxWidth: "100%" }} /></div>
  <div style={{textAlign:"center", marginBottom:"auto"}}>
    <h3>{e.name}</h3>
    <h5>{e.title}</h5>
    <p>{e.email} </p>
    </div>
    </Col>
    <Col/>
    </>
} else {
  return <Col key={heading+index}>
  <div><img className="d-block" src={e.image} style={{ maxWidth: "100%" }} /></div>
  <div style={{textAlign:"center", marginBottom:"auto"}}>
    <h3>{e.name}</h3>
    <h5>{e.title}</h5>
    <p>{e.email} </p>
    </div>
    </Col>
}


          })}
          </Row>
          <Row  style={{ margin: "20px" }}>
            {fullText}
        </Row>
     
        </Row></>:<></>}
  


        <Row className="d-none d-md-flex" onClick={()=>{setVis(!vis)}} style={{ background: backgroundColor, color:textColor }}>
          <Col xs="2" style={{ marginTop: "auto", marginBottom: "auto" }}><img className="d-block" src={logo} style={{ marginBottom:"10px", marginTop:"10px",maxWidth: "100%" }} /></Col>
          <Col xs="10" style={{ padding: "20px" }}>
          <p>{heading}</p>
            <div style={{textAlign:"right"}}><h3>{vis?"Reduce":"Expand"}</h3></div> </Col>
        </Row>
        {vis?<Row className="d-none d-md-flex" onClick={()=>{setVis(false)}} style={{ background: backgroundColor, color:textColor , paddingTop:"20px", paddingBottom:"20px"  }}>
        <Col xs="2" style={{ marginBottom: "auto",verticalAlign:"bottom", paddingTop:"20px" }}>


        {founders.map((e,index)=>{
          return <div key={heading+index}>
                    <div><img className="d-block" src={e.image} style={{maxWidth: "100%" }} /></div>
                    <div style={{textAlign:"center", marginBottom:"auto"}}>
                    <h5>{e.name}</h5>
                        <p>{e.title}</p>
                        <div style={{fontSize:"8px", width:"100%"}}>{e.email} </div>
                      </div></div>
          })}
          </Col>
          <Col xs="10" style={{ padding: "20px" }}>
          {fullText}
          </Col>
     
        </Row>:<></>}
        </>
}

function App() {


  const [fairlyD, setFairly] = useState(false);
  const [modellicityD, setModellicity] = useState(false);
  const [puzzulD, setPuzzul] = useState(false);
  const [bfocusD, setBfocus] = useState(false);
  const [iModXD, setIModX ] = useState(false);

  /*
  const {state,enter,exit} = useTransitionControl();

  const style ={
    ... defaultStyle,
    ... transitionStyles(state)
  } 
  */
  return (
    <Container style={{ color: "#ffffff" }} >
      <Row>
        <Col />
        <Col><img className="d-block" src={iModX} style={{ padding: "20px", maxWidth: "100%" }} /> </Col>
        <Col />
      </Row>
      <Row style={{ color: "#000000" }} >
        <Col />
        <Col style={{ textAlign: "center" }}><h1>Members</h1> </Col>
        <Col />
      </Row>

      <Block vis={iModXD} setVis={setIModX} 
      logo={iModXGif}
      heading = {"Our Mission is to “UBERIZE” the global model and data infrastructure and empower all key stakeholders of model ecosystem"}
      backgroundColor = {"#4d4347"}
      founders = {[
        {
          name:"Alexander Shipilov",
          title:"CEO iModX",
          email:"ashipilov@imodx.org",
          image:alexShipilov
        },
        {
          name:"Yaping Jiang",
          title:"CRO iModX",
          email:"yjiang@imodx.org",
          image:yapingJiang
        }
      ]}
      fullText = {
<>

<h1>Built on Blockchain, iModX connects you to Data and Models.</h1>
<p>iModX is a new marketplace for Models, Data, and Cloud Resources. This new marketplace creates communities and ecosystems for their respective stakeholders with distinctive features:</p>

<h1>The Democratization of data and models</h1>

<p>Access for qualified professionals and smaller institutions with reduced barrier to access for qualified/registered professionals and institutions</p>

<p>iModX team will work with the consortium members and the community to bring the iModX Blockchain prototype to a production-ready state. There will be a series of pilot projects with regulated financial and nonregulated institutions on development of Enterprise Version of iModX, where a private and permissioned model blockchain will be owned by the financial institution. In particular, this work will focus on ensuring the security, performance, and scalability of the protocol and implementation.</p>

<p>Along with the iModX Blockchain development we will be building the repository of models and data in a blockchain friendly formats. The selective models from the existing public libraries (QuantLib, GitHub, etc.) and proprietary software packages will be translated, compiled, hashed, encrypted and put into the Repository. The IMDE – Integrated Model Development Environment tools and APIs will be developed and well-documented to enable model developers, validators and users to interact with the iModX Blockchain and Repository.</p>

<p>The separate channels of the iModX Payment Blockchain dedicated to the payments and custodial services will be developed of the main model blockchain.</p>

</>

      }
      
      />

      <Block vis={fairlyD} setVis={setFairly} 
      logo={fairly}
      heading = {"FAIRLY helps organizations analyze AI algorithms and build more ethical, responsible, and compliant AI systems.  We work with you to ensure your systems produce equitable outcomes for all your stakeholders, while advancing  your business goals and meeting government regulatory requirements."}
      backgroundColor = {"#14283a"}
      founders = {[
        {
          name:"David Van Bruwaene",
          title:"CEO Fairly AI",
          email:"david@fairly.ai",
          image:davidVanBruwaene
        },
        {
          name:"Fion Lee-Madan",
          title:"COO Fairly AI",
          email:"fion@fairly.ai",
          image:fionLeeMadan
        }
      ]}
      fullText = {
<>
<h3>Good governance is good business</h3>
<p>FAIRLY helps organizations analyze AI algorithms and build more ethical, responsible, and compliant AI systems.  We work with you to ensure your systems produce equitable outcomes for all your stakeholders, while advancing  your business goals and meeting government regulatory requirements.</p>  

<h5>AI Readiness Planner</h5>
<p>An AI governance plan is the most important tool to ensure AI projects are done successfully. FAIRLY has created a planning and gap analysis tool that brings together the best practices and regulatory guidance. </p>

<h5>Cross-Functional Reporting </h5>
<p>FAIRLY easily connects to your data, to calculate your AI system’s fairness and performance-related metrics, generates model validation reports to accelerate go-to-market for your AI products and services.</p>

<h5>Validation Engine</h5>
<p>FAIRLY's AI experts can work directly with your teams to share best practices to root out bias, protect privacy, ensure transparency, and enable explainability in your AI systems. Try our AI Validation Engine today.</p>
 

</>

      }
      
      />

<Block vis={modellicityD} setVis={setModellicity} 
      logo={modellicity}
      heading = {"Modellicity uses statistics and modelling to provide clients in the credit risk industry with insightful analyses and realistic predictions, so that they can make the best decisions to maximize revenue and minimize risk."}
      backgroundColor = {"#215b91"}
      founders = {[
        {
          name:"Basil Singer",
          title:"CEO Modellicity",
          email:"basil.singer@modellicity.com",
          image:basilSinger

        },
      ]}
      fullText = {
<>
<h1>Modellicity Catalog</h1>

          <p>In Modellicity, we specialize in statistical modelling and analytics to help our retail and business clients
gain insight to make good decisions. If you need help in any of these items, we are here for you:</p>
<p>(1) Assessing current model performance and determining best course of action to ensure they align
with business needs (e.g., rebuilding a model vs. using existing model for underwriting automation)</p>
<p>(2) Pooling large datasets from multiple sources at different levels of granularity and applying necessary
treatments for model development</p>
<p>(3) Pulling historical data on a portfolio segment that has changed over time</p>
<p>(4) Developing, vetting, and enhancing multi-year financial projection models to allow for scenario
analysis and additional customization of assumptions</p>
<p>(5) Quickly develop a predictive model with corresponding model documentation (via an internally
developed internal software tool that streamlines the model development process, with data treatment,
feature engineering, variable selection, model selection and calibration, backtesting, and reporting
functionality)</p>
<p>(6) Vetting inhouse pricing models, developing corresponding documentation of methodology,
identifying existing weaknesses, and providing enhancement recommendations and monitoring plans</p>
<p>(7) Benchmarking existing models that target the same portfolio (e.g., old vs. new) and providing an
impact analysis</p>
<p>(8) Quantifying and evaluating model risk of automated real-estate pricing tools, providing an audit-
approved ongoing monitoring plan</p>
<p>(9) Training data scientists on how to develop and validate models (10) Developing loss and prepayment
curves for lending companies</p>
<p>(10) Providing deployment requirements for model implementation (12) Reverse engineering and
documenting existing models written in production code (e.g., Java, SAS, C++) with no prior
documentation</p>

<h3>Audiences we cover:</h3>
<p>(1) Start-up --&gt; Model development, model documentation, model validation, model development
training</p>
<p>(2) Medium-sized company --&gt; Data querying from existing database, model development, model
documentation, model validation, model deployment specifications</p>
<p>(3) Large company --&gt; Big data querying and pooling from multipled databases, data treatment and
multi-level aggregation, model development, model validation, model deployment specifications</p>

<p>(4) Individuals --&gt; Training in model development Tools we are specialized in: Python (scikit-learn,
TensorFlow, Keras, pandas, NumPy, Matplotlib) SQL SAS R C++ Java</p>

<h3>Areas applied:</h3>
<p>Auto-lending (loss and prepayment modelling<br/> 
Retail mortgage lending (default modelling)<br/> 
Commercial and retail real-estate investing (default modelling)<br/> 
Small &amp; medium enterprise business lending (default modelling)<br/> 
Retail investing (default modelling)<br/> 
Credit card (default modelling)<br/> 
Loan adjudication/underwriting (automation and risk analysis)<br/> 
Financial projection (analysis, enhancement, and scenario analysis)<br/> 
Healthcare (hospital re-admittance prediction modelling)<br/> 
Entertainment (movie success prediction modelling)<br/> 
Customer service (sentiment analysis)</p>

</>

      }
      
      />



<Block vis={puzzulD} setVis={setPuzzul} 
      logo={puzzul}
      heading = {"Community Governed, Socially Oriented, Data Management. Puzzul allows communities to manage the data they create and have the ability to share with educational insitutions and sell to corporation as a autonomous group."}
      backgroundColor = {"#85c4ca"}
      founders = {[
        {
          name:"Kristina Flynn",
          title:"CEO Puzzul",
          email:"kristina.flynn@puzzul.io",
          image:kristinaFlynn
        },
      ]}
      fullText = {
<>
<h1>Puzzul</h1>


<h3>DATA IS THE NEW OIL</h3>
<p>Companies are realizing that the data they have on their clients is becoming their most valuable resource.</p>

<h3>BUT IT CAN BE BIASED</h3>
<p>The majority culture creates the majority of data. This means it’s not representative of minority communities.</p>

<h3>BUT IT CAN BE BIASED</h3>THIS HURTS PEOPLE
<p>Minorities have a history of not wanting to share data and being exploited when they do. Puzzul gives vulnerable communities control of their data. But let’s them work with companies so everyone can benefit.</p>
       



</>

      }
      
      />

<Block vis={bfocusD} setVis={setBfocus} 
      logo={bfocus}
      heading = {"BfocUS Group is a trusted partner and marketing consulting firm that not only understands BIPOC experiences but sees through the same lenses. Our team is the pulse of multiple communities, connected by one common vein of expression through our thoughts, emotions and actions."}
      backgroundColor = {"#eeeeee"}
      textColor={"#000000"}
      founders = {[
        {
          name:"Connie Amartey",
          title:"CEO Bfocus",
          email:"",
          image:connieAmartey
        },
      ]}
      fullText = {
<>
<h1>BFocus</h1>

<p>BfocUS Group is a trusted partner and marketing consulting firm that not only understands BIPOC experiences but sees through the same lenses. Our team is the pulse of multiple communities, connected by one common vein of expression through our thoughts, emotions and actions.</p>

<p>We have established extensive, trusted relationships throughout various communities with influencers, leaders, social groups, event managers, IT, media and the entertainment industry.</p>

<p>We gather accurate, relatable insights from BIPOC communities through trusted networks and data pools. Results are substantiated with data modeling and machine learning, allowing you greater insight into the communities which are now being recognized both in terms of influence and buying power.</p>


<p>Urban is a lifestyle, a feeling that is embraced that brings unification across cultures and communities resulting in trends, international cuisine, fashion and music appreciation. It is a universal language where words are spoken through movement, style and arts. Its representations and interpretations differ between each country, city and community members</p>

<p>BfocUS sweeps aside the politics and gives you real world objective information that you can use to pivot in today's changing social climate.</p>

<p>Creative consultation and management solution for the BIPOC Community driven by authentic connection, verified by data.</p>

<p>Our objective is simple, no biases, no guessing just the real world feedback and objective opinions to ensure inclusive marketing strategies</p>

<p>"You want people who have the good taste to endorse your product always. The people who are leaders in the culture are the best brand-builders. If they choose your product, then of course you have added credibility.” Hip Hop mogul Russell Simmons</p>



</>

      }
      
      />



    </Container>
  );
}
/*

      <Row>
        <Col />
        <Col><img src={modellicity} height={150} /></Col>
        <Col />
      </Row>
      <Row>
        <Col>
          Modellicity uses statistics and modelling to provide clients in the credit risk industry with insightful analyses and realistic predictions, so that they can make the best decisions to maximize revenue and minimize risk.
          </Col>
      </Row>



      <Row>
        <Col><img src={headShot} /></Col>
        <Col>
          <h3>Name</h3>
          <h4>Title</h4>
          <p>Description</p>

        </Col>
      </Row>
      */

export default App;
